module.exports = __webpack_public_path__ + "img/registration_man.65db73f5.png";